import './interactive-report-communication'

import setupLinkInputsToRemarks from './setup-link-inputs-to-remarks'
import focusTextPropertyFieldFromUrl from './focus-text-property-field-from-url'

import './inbox/company-inbox'
import './inbox/firm-inbox'
import './inbox/inbox-unread-count'
import './inbox/pulse-inbox'
import './inbox/workflow-inbox'

setupLinkInputsToRemarks()
focusTextPropertyFieldFromUrl()
